<template>
	<div class="container" v-if="list.length >0">
        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="category">
                    <a class="category-top">{{name}}</a>
                    <a class="category-bottom">{{enname}}</a>
                </div>
            </div>
            <div class="panel-body " style="padding:0px;">
                <ul  :class="show?'list-group celebrity long-text showLongText':'list-group celebrity long-text hideLongText'" >
                            <li class="list-group-item" v-for="(item, index) in list">
                            	<van-row v-if="index %2 ==0">
															  <van-col span="15">
															  	<h5>{{item.Celebrity}}</h5>
                                        <p v-html="item.Detail"></p>
															  </van-col>
															  <van-col span="1"></van-col>
															  <van-col span="8">
															  	<img :src="item.img_urls">
															  </van-col>
															</van-row>
															<van-row v-else>
															  <van-col span="8">
															  	<img :src="item.img_urls">
															  </van-col>
															  <van-col span="1"></van-col>
															  <van-col span="15">
															  	
															  	<h5>{{item.Celebrity}}</h5>
                                        <p v-html="item.Detail"></p>
															  </van-col>
															</van-row>
                            </li>
                </ul>

                <button type="button" class="showMore btn btn-primary btn-lg btn-block" @click="show = !show" v-if="list.length > 1"></button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  data(){
    return {
      show: false,
    }
  },
  props: {
  	list: {
  		type: Array||Object,
  		require: true
  	},
  	name: {
  		type: String,
  		default: '当地名人'
  	},
  	enname: {
  		type: String,
  		default: 'Celebrity'
  	}
  },
  components: {  },
  mounted: function () {
  },
  methods: {
  }
};

</script>
<style>
	.panel-body img{
		border-radius: 6px;
	}
</style>
